<div class="fixed inset-0 z-9999 flex items-center justify-center p-6"><!--bg-[#4a5c3e]-->
  <div class="w-full max-w-150 rounded-md text-mksoft-subtitle px-9 py-10 text-center bg-smartsheep-cream">

    <!-- Logo -->
    <div class="mb-8 flex items-center justify-center gap-3">
      <!-- <div class="flex h-10 w-10 items-center justify-center rounded-[10px] bg-[#4A5C3E]">
         <svg width="24" height="24" viewBox="0 0 200 200" fill="none">
           <circle cx="60" cy="108" r="28" fill="#E8E0CC"/>
           <circle cx="82" cy="88" r="33" fill="white"/>
           <circle cx="110" cy="84" r="36" fill="white"/>
           <circle cx="134" cy="100" r="27" fill="#E8E0CC"/>
           <ellipse cx="97" cy="126" rx="51" ry="32" fill="white"/>
           <ellipse cx="158" cy="104" rx="28" ry="26" fill="#DDD0BB"/>
           <ellipse cx="169" cy="99" rx="6.5" ry="6" fill="#2A1E10"/>
           <circle cx="171" cy="97" r="2.5" fill="white"/>
         </svg>
       </div>-->

      <span class=" text-[36px] font-black tracking-[-0.02em] text-[#3D2B1A]">
        SmartSheep <br/>
        <span class="pt-1 text-sm font-normal">Die Herde kennt <em class="text-smartsheep-gold font-bold text-lg"> kein Papier </em> mehr</span>
      </span>


    </div>

    <!-- Spinner mit Schaf -->
   <div class="relative mx-auto mb-6 h-[72px] w-[72px]">
      <div
        class="h-[72px] w-[72px] animate-spin rounded-full border-[3px] border-[#EDE5D4] transition-colors duration-300"
        [style.border-top-color]="currentStep() === 4 ? '#C8943A' : '#4A5C3E'">
      </div>

      <div class="absolute inset-2 flex items-center justify-center rounded-full bg-[#F5F0E8]">
        <svg width="28" height="28" viewBox="0 0 200 200" fill="none">
          <circle cx="60" cy="108" r="28" fill="#E8E0CC"/>
          <circle cx="82" cy="88" r="33" fill="white"/>
          <circle cx="110" cy="84" r="36" fill="white"/>
          <circle cx="134" cy="100" r="27" fill="#E8E0CC"/>
          <ellipse cx="97" cy="126" rx="51" ry="32" fill="white"/>
          <ellipse cx="158" cy="104" rx="28" ry="26" fill="#DDD0BB"/>
          <ellipse cx="169" cy="99" rx="6.5" ry="6" fill="#2A1E10"/>
          <circle cx="171" cy="97" r="2.5" fill="white"/>
        </svg>
      </div>
    </div>

    <!-- Titel -->
    <h2 class="mb-1.5 text-[26px] font-black leading-tight text-smartsheep-bark">
      {{ stepTitle() }}
    </h2>
    <p class="mb-6 text-xs font-dmsans text-mksoft-subtitle">
      {{ stepSubtitle() }}
    </p>

    <!-- Progress Bar -->
    <div class="mb-2 h-1 overflow-hidden rounded-xs bg-smartsheep-warm200">
      <div
        class="h-full rounded-xs bg-smartsheep-gold transition-all duration-700 ease-out"
        [style.width]="progressPct() + '%'">
      </div>
    </div>

    <p class="mb-6 text-[12px] text-mksoft-subtitle">
      <span class="font-semibold text-smartsheep-gold">{{ progressPct() }} %</span>
      &nbsp;abgeschlossen
    </p>

    <!-- Schritte -->
    <div class="flex flex-col gap-2.5 text-left">
      @for (s of provisionSteps; track s.id) {
        <div
          class="flex items-center gap-3 rounded-[10px] px-3.5 py-2.5 transition-all duration-300"
          [ngClass]="{
            'bg-smartsheep-warm200': currentStep() === s.id,
            'bg-[#F5F0E8]': currentStep() > s.id,
            'opacity-40': currentStep() < s.id
          }">

          <div
            class="flex h-6.5 w-6.5 shrink-0 items-center justify-center rounded-full text-[11px] font-bold"
            [ngClass]="{
              'bg-smartsheep-gold text-white': currentStep() > s.id,
              'animate-pulse bg-[#C8943A] text-white': currentStep() === s.id,
              'bg-[#EDE5D4] text-[#9B9488]': currentStep() < s.id
            }">

            @if (currentStep() > s.id) {
             <span class="text-white">✓</span>
            } @else if (currentStep() === s.id) {
              ●
            } @else {
              {{ s.id }}
            }
          </div>

          <div>
            <div class="text-[15px] font-bold text-smartsheep-bark">
              {{ s.label }}
            </div>
            <div class="mt-px text-xs font-dmsans text-mksoft-subtitlee">
              {{ s.desc }}
            </div>
          </div>
        </div>
      }
    </div>

  </div>
</div>
